<template>
<div id="audit-DSP">
    <c-body class="c-body">
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
					<Input v-model="tableParams.keyword" 
						   placeholder="广告主id/账号/推广id/推广名称"
						   class="header-search"
						   icon="android-search"
						   @on-keydown.enter="getCampaignList(true)"
						   @on-click="getCampaignList(true)" />

                    <!-- 批量操作 -->
					<button @click="showCreateAudit(0)" class="header-button-ghost">
						<span class="header-button-ghost-span">
							<span>批量审批</span>
							<i style="color:#23c52f;margin-left:0.05rem;">{{selectedCount}}</i>
						</span>
						<i class="icon header-button-ghost-down"></i>
					</button>
                </div>
            </div>
        </header>
        <section slot="section" class="c-body-section">
            <table class="c-body-table">
				<!-- 表头 -->
				<thead class="table-thead">
					<tr class="table-tr">
						<td class="table-td-primary" @click.stop="selectedCurrentPage">
							<div class="icon-wrap">
								<span class="icon icon-checkbox"
								  :class="{'active':selectedAll}"></span>
							</div>
						</td>
						<td class="table-td-primary" v-for="(item) in tableList"
                            :key="item.title">{{item.title}}
						</td>
					</tr>
				</thead>
				<!-- 表头 -->                
				<tbody class="table-tbody">
            		<tr v-for="(item,index) in originData"
                        class="table-tr"
				        :key="index">
						<td class="table-td-primary" @click.stop="item.selected=!item.selected">
                               <div class="icon-wrap">
                                   <span class="icon icon-checkbox"
                                   :class="{'active':item.selected}"></span>
                               </div>
						</td>
                        <td @click="showCreateAudit(item.offerId)" class="table-td-primary table-td-btn">审批</td>
						<td class="table-td-primary cursor-pointer"
						    style="max-width:2.2rem"
						    :title="item.clickUrl">
                            <div class="showregular">{{item.clickUrl}}</div>
						</td>
						<td class="table-td-primary"
						    style="max-width:1.8rem">
							<img v-if="item.imgUrl" class="create-img cursor-pointer"
							     @click="showCreateDetail(item)"
							     :src="item.imgUrl" />
                            <span v-else>No Data</span>
						</td>
						<td class="table-td-primary">{{item.bidPrice!='0.00'?item.bidPrice:'不限'}}</td>
						<td class="table-td-primary">{{item.publisherId}}</td>
						<td class="table-td-primary cursor-pointer showregular"
						    :title="item.publisherName"
                            style="max-width:2rem;">{{item.publisherName}}</td>
						<td class="table-td-primary">{{item.campaignId}}</td>
						<td class="table-td-primary cursor-pointer showregular"
						    :title="item.campaignName"
                            style="max-width:2rem;">{{item.campaignName}}</td>
						<td class="table-td-primary">{{item.modifyTime}}</td>
					</tr>
				</tbody>
            </table>
        </section>
        <footer slot="footer" class="c-body-footer">
        	<!-- 分页器 -->
			<c-page :table-params.sync="tableParams" 
                    :page-bean.sync="pageBean"
                    class="foot-row"
                    @on-change="getCampaignList(false)"
                    @on-page-size-change="getCampaignList(true)" />
        </footer>
    </c-body>

	<!-- 创意详情 -->
	<Modal title="创意详情"
	       v-model="show.createDetail">
		<div v-if="currentCreate.creativeType==2"
		     class="create-detail">
			<div class="create-detail-row">
				<div class="create-detail-left">标题：</div>
				<div class="create-detail-right">{{currentCreate.title}}</div>
			</div>
			<div class="create-detail-row">
				<div class="create-detail-left">描述：</div>
				<div class="create-detail-right">{{currentCreate.description}}</div>
			</div>
			<div class="create-detail-row">
				<div class="create-detail-left">按钮文案：</div>
				<div class="create-detail-right">{{currentCreate.buttonText}}</div>
			</div>
			<div class="create-detail-row">
				<div class="create-detail-left">图片：</div>
				<div><img :src="currentCreate.imgUrl" /></div>
			</div>
			<div class="create-detail-row">
				<div class="create-detail-left">LOGO：</div>
				<div><img class="create-detail-logo"
					     :src="currentCreate.iconUrl" /></div>
			</div>
		</div>
		<div v-if="currentCreate.creativeType==1||currentCreate.creativeType==4"
		     class="create-detail">
			<div class="create-detail-row">
				<div class="create-detail-right">
					<img :src="currentCreate.imgUrl" />
				</div>
			</div>
		</div>
		<!-- 去除底部按钮 -->
		<div slot="footer"></div>
	</Modal>
	<!-- 创意详情 -->

	<!-- 创意审批 -->
	<Modal title="审批"
	       v-model="show.createAudit"
	       width="500"
	       @on-ok="auditCreate">
		<div class="create-detail">
			<div class="create-detail-row">
                <RadioGroup v-model="auditData.verifyStatus">
                    <Radio label="2" style="margin-right:0.4rem;">拒绝</Radio>
                    <Radio label="1">通过</Radio>
                </RadioGroup>
			</div>
			<div v-show="auditData.verifyStatus==2"
			     class="create-detail-row column">
				<span class="row-title">拒绝原因：</span>
				<Input v-model="auditData.remark"
                       :maxlength="100"
				       type="textarea"
				       :rows="4"
				       placeholder="请输入拒绝原因" />
			</div>
		</div>
	</Modal>
	<!-- 创意审批 -->
</div>
</template>
<script>
import cBody from '@/components/commons/cBody.vue';
import cPage from '@/components/commons/cPage.vue';
export default {
    name: 'AuditListDSP',
    components: {
        cBody,
        cPage,
    },
    data() {
        return {
            auditData: {
                verifyStatus: '2',
                remark: '',
                offerIds: '',
            },
            batchFlag: false,
            show: {
                createDetail: false, //显示创意详情
                createAudit: false, //显示审批创意
            },
            currentCreate: {},
            //图片尺寸
            sizeList: ['占位元素', '300x250', '1200x628', '720x1280', '1280x720', '320x50', '320x480', '1200x627', '320x200'],
            //表头
            tableList: [
                { title: '操作' },
                { title: '落地页' },
                { title: '创意' },
                { title: '每日预算' },
                { title: '广告主ID' },
                { title: '广告主名称' },
                { title: '推广ID' },
                { title: '推广名称' },
                { title: '最后更新时间' },
            ],
            //原始表格数据
            originData: [],
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 0,
            },
            tableParams: {
                keyword: '',
                page: 1,
                pageSize: 10,
                startDate: '',
                endDate: '',
            },
        };
    },
    computed: {
        //已选择的数量
        selectedCount() {
            return this.originData.filter(item => item.selected).length;
        },
        //全选
        selectedAll() {
            return this.originData.length && this.originData.every(item => item.selected);
        },
    },
    mounted() {
        this.getCampaignList();
    },
    methods: {
        /*
		 * @description 获取推广列表数据
		 */
        async getCampaignList() {
            const res = await this.$axios.get(this.$port.admin.rtbListWaitVerifyOffer, { params: this.tableParams });
            this.originData = res.data.offers.map(item => {
                item.selected = false;
                item.imgUrl = item.imgUrl ? item.imgUrl.split(',')[0] : '';
                return item;
            });
            this.pageBean = res.data.pageBean;
        },
        /*
		 * @description 选择当前页面的全部推广
		 */
        selectedCurrentPage() {
            let bool = !this.selectedAll;
            this.originData.forEach(item => (item.selected = bool));
        },
        /*
		 * @description 显示创意详情
		 * @params item:obj 推广对象
		 */
        showCreateDetail(item) {
            this.show.createDetail = true;
            this.currentCreate = item;
        },
        /*
		 * @description 显示审批创意
		 * @params id:number 创意id 0则表示批量审核
		 */
        showCreateAudit(id) {
            //批量且没有选择创意
            if (!id && !this.selectedCount) {
                this.$Message.warning('请先选择要审核的创意', 1500);
                return;
            }
            this.show.createAudit = true;
            this.auditData.offerIds = `${id}`;
        },
        /*
		 * @description 审批创意
		 */
        async auditCreate() {
            let data = this.auditData;
            //批量选择
            if (data.offerIds == '0')
                data.offerIds = this.originData
                    .filter(item => item.selected)
                    .map(item => item.offerId)
                    .join(',');
            const res = await this.$axios.get(this.$port.admin.verifyOffer, { params: data });
            if (res.status == '200') {
                this.$Modal.success({
                    title: '审批成功',
                    content: res.message,
                });
                this.getCampaignList();
            }
        },
    },
};
</script>
<style lang="scss">
@import '../../style/frequently';
#audit-DSP {
    #c-body .header-search {
        width: 2.2rem;
    }
    .overflow-text {
        min-width: 1.6rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
    }
    .create-img {
        width: auto;
        max-width: 1.6rem;
        max-height: 0.8rem;
        margin: 0.1rem auto;
    }
}
// 创意审批浮窗
.examine-popup-box {
    padding: 0.1rem;
    display: flex;
    flex-direction: column;
    .examine-title {
        font-size: 0.18rem;
        text-align: left;
    }
    .examine-table {
        background: white;
        margin-top: 0.2rem;
        & td,
        & th {
            border: 1px solid #dedde0;
        }
        & td {
            background: white;
            vertical-align: center;
        }
        .createImg {
            width: 80%;
            margin: 0.1rem auto;
        }
    }
}
//创意详情
.create-detail {
    .create-detail-row {
        display: flex;
        align-items: flex-start;
        font-size: 0.14rem;
        line-height: 0.2rem;
        .create-detail-left {
            flex: 0 0 0.7rem;
            text-align: right;
            margin-right: 0.1rem;
        }
        .create-detail-right {
            flex: 1 1 auto;
            img {
                width: auto;
                margin: 0 auto;
            }
        }
        .create-detail-logo {
            width: 84px;
            height: 84px;
        }
        .ivu-radio-wrapper {
            font-size: 0.16rem;
        }
    }
    .column {
        margin-top: 0.2rem;
        flex-direction: column;
        padding: 0;
    }
    .row-title {
        margin-bottom: 0.1rem;
    }
    .create-detail-row:not(:last-child) {
        margin-bottom: 0.15rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Audit/AuditDSP.vue